var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect initialColor" },
    [
      _vm.$store.state.enableOrderModeSelection
        ? _c("div", { staticClass: "text-center" }, [
            _c(
              "div",
              { staticClass: "mobile pa-3 pt-7" },
              [
                _c("OrderModeSwitcher", {
                  attrs: { availableModes: _vm.availableOrderModes },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "tablet pl-2 pr-2 pt-7 pb-4" },
              [
                _c("OrderModeSwitcher", {
                  attrs: { availableModes: _vm.availableOrderModes },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "v-container",
        { staticClass: "bgw myBorderRadius pt-2 mt-3" },
        [
          _vm.cartItems.length === 0
            ? _c("div", { staticClass: "text-center mt-5" }, [
                _c("div", { staticClass: "spacer-25" }),
                _c("h3", {}, [_vm._v("Dein Korb ist aktuell leer")]),
                _c("div", { staticClass: "spacer-25" }),
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "btn-df",
                        attrs: { rounded: "" },
                        nativeOn: {
                          "&click": function ($event) {
                            return _vm.$ebus.$emit("goto", {
                              name: "Sortiment",
                            })
                          },
                        },
                      },
                      [_vm._v(" Zum Sortiment ")]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.cartItems.length > 0
            ? _c("div", { staticClass: "pmRow" }, [
                _c("div", { staticClass: "spacer-15" }),
                _c("table", { staticClass: "theader maxw" }, [
                  _c("tr", { staticClass: "boldHead" }, [
                    _c(
                      "td",
                      {
                        staticClass: "text-left",
                        staticStyle: { width: "auto" },
                      },
                      [_vm._v(" Artikel im Korb ")]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "text-center",
                        staticStyle: { width: "154px" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "anzahl",
                            staticStyle: { width: "154px" },
                          },
                          [
                            _vm._v("Anzahl"),
                            _c("span", { staticClass: "hidden-sm-and-up" }, [
                              _vm._v("/Preis"),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "text-center hidden-xs-only",
                        staticStyle: { width: "90px" },
                      },
                      [_vm._v("Preis")]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._l(_vm.cartItems, function (item) {
            return _c("div", { staticClass: "itemRow pmRow" }, [
              item.isCoupon
                ? _c(
                    "table",
                    {
                      staticClass: "maxw items pointer table-collapse",
                      on: {
                        "&click": function ($event) {
                          $event.stopPropagation()
                          return _vm.showCouponInfo(item)
                        },
                      },
                    },
                    [
                      _c("tr", [
                        _c("td", { staticClass: "b text-left" }, [
                          _c("div", {}, [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("noHtml")(item.nameToDisplay)) +
                                  " "
                              ),
                            ]),
                            item.text
                              ? _c("div", { staticClass: "displayExtras" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("noHtml")(item.text)) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _c(
                          "td",
                          { staticClass: "c counterStuff" },
                          [
                            _c(
                              "v-row",
                              [
                                _c("v-col", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-end align-center maxh",
                                      staticStyle: { opacity: "0" },
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "minusImg pointer",
                                        attrs: {
                                          src: require("../assets/icons/item-minus.png"),
                                        },
                                      }),
                                      _c("div", [_vm._v("0")]),
                                      _c("img", {
                                        staticClass: "plusImg pointer",
                                        attrs: {
                                          src: require("../assets/icons/item-plus.png"),
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("v-col", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-end align-center maxh",
                                    },
                                    [
                                      item.type === "bundle"
                                        ? _c(
                                            "div",
                                            { staticClass: "text-no-wrap" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("price")(item.amount)
                                                ) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      item.type === "amount"
                                        ? _c(
                                            "div",
                                            { staticClass: "text-no-wrap" },
                                            [
                                              _vm._v(
                                                "-" +
                                                  _vm._s(
                                                    _vm._f("price")(item.amount)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      item.type === "discount"
                                        ? _c(
                                            "div",
                                            { staticClass: "text-no-wrap" },
                                            [
                                              _vm._v(
                                                "-" +
                                                  _vm._s(item.discount) +
                                                  "% "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "ml-2 myBlack pointer",
                                          attrs: { medium: "" },
                                          nativeOn: {
                                            "&click": function ($event) {
                                              $event.stopPropagation()
                                              return _vm.deleteCartItem(item)
                                            },
                                          },
                                        },
                                        [_vm._v("mdi-delete-forever ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                : _c("table", { staticClass: "maxw items" }, [
                    _c("tr", [
                      _c("td", { staticClass: "b text-left" }, [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function ($event) {
                                return _vm.gotoItem(item)
                              },
                            },
                          },
                          [
                            _c("div", [
                              _c("span", [
                                item.gang
                                  ? _c("div", { staticClass: "gang" }, [
                                      _vm._v(
                                        _vm._s(_vm._f("uppercase")(item.gang)) +
                                          ": "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]),
                              item.isOffer
                                ? _c("span", [
                                    item.usecase === "takeAway"
                                      ? _c("span", [_vm._v("Abholer-Angebot")])
                                      : _c("span", [_vm._v("Angebot")]),
                                    _vm._v(": "),
                                  ])
                                : _vm._e(),
                              _vm._v(
                                " " +
                                  _vm._s(item.nameToDisplay) +
                                  " " +
                                  _vm._s(_vm.displayItemVol(item)) +
                                  " "
                              ),
                            ]),
                            item.extras.length > 0
                              ? _c("div", { staticClass: "displayExtras" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("extrasList")(item.extras, true)
                                      ) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm.$store.state.enableItemNote
                          ? _c(
                              "div",
                              {
                                staticClass: "displayExtras pointer",
                                on: {
                                  "&click": function ($event) {
                                    return _vm.editNotes(item)
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "d-inline-block" }, [
                                  _vm._v("Anmerkung"),
                                ]),
                                item.notes.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "d-inline-block notes" },
                                      [_vm._v(": " + _vm._s(item.notes) + " ")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "d-inline-block" },
                                  [
                                    _vm._v("  "),
                                    _c("v-icon", { staticClass: "myBlack" }, [
                                      _vm._v("mdi-pencil"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _c("div", { staticClass: "pt-3" }),
                      ]),
                      _c(
                        "td",
                        { staticClass: "c counterStuff" },
                        [
                          _c(
                            "v-row",
                            [
                              _c("v-col", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex align-center maxh",
                                    class: { "justify-end": !item.unikat },
                                  },
                                  [
                                    !item.unikat
                                      ? _c("img", {
                                          staticClass: "minusImg pointer",
                                          attrs: {
                                            src: require("../assets/icons/item-minus.png"),
                                          },
                                          on: {
                                            "&click": function ($event) {
                                              return _vm.decrementCartItem(item)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    _c("div", [_vm._v(_vm._s(item.count))]),
                                    !item.unikat
                                      ? _c("img", {
                                          staticClass: "plusImg pointer",
                                          attrs: {
                                            src: require("../assets/icons/item-plus.png"),
                                          },
                                          on: {
                                            "&click": function ($event) {
                                              return _vm.incrementCartItem(item)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ]),
                              _c("v-col", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-end align-center maxh",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex d-sm-block" },
                                      [
                                        item.originalItemTotal
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-decoration-line-through",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm._f("price")(
                                                        item.originalItemTotal
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c("div", {
                                          staticClass: "pl-3 hidden-sm-and-up",
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "text-no-wrap" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("price")(item.itemTotal)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-2 myBlack pointer",
                                        attrs: { medium: "", medium: "" },
                                        nativeOn: {
                                          "&click": function ($event) {
                                            return _vm.deleteCartItem(item)
                                          },
                                        },
                                      },
                                      [_vm._v("mdi-delete-forever ")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
            ])
          }),
          _vm.cartItems.length > 0
            ? _c(
                "div",
                {
                  staticClass: "indented mt-6",
                  staticStyle: { "padding-right": "16px" },
                },
                [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("div", { staticClass: "hidden-xs-only" }, [
                      _vm.$store.getters.enableStempel &&
                      !_vm.$store.getters.hasStempelInCart
                        ? _c(
                            "div",
                            {
                              staticClass: "mb-4",
                              staticStyle: { "max-width": "318px" },
                            },
                            [_c("SmallStempelkarte")],
                            1
                          )
                        : _vm._e(),
                      _vm.$store.state.enableEnterCode
                        ? _c("div", [_c("EnterCode")], 1)
                        : _vm._e(),
                    ]),
                    _c("div", { staticClass: "text-right flex-grow-1" }, [
                      _c("div", { staticClass: "d-inline-block" }, [
                        _c("table", { staticClass: "mySumTable" }, [
                          _vm.$store.state.rabattSum > 0
                            ? _c("tr", [
                                _c("td", [_vm._v("Rabattsumme:")]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("price")(
                                        _vm.$store.state.rabattSum
                                      )
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _c("tr", [
                            _c("td", [_c("h3", [_vm._v("Gesamt:")])]),
                            _c("td", [
                              _c("h3", { staticClass: "text-no-wrap" }, [
                                _vm._v(_vm._s(_vm._f("price")(_vm.total))),
                              ]),
                            ]),
                          ]),
                          _vm.takeAwayTotal !== _vm.total
                            ? _c("tr", [
                                _c("td", [_c("h3", [_vm._v("Abholpreis:")])]),
                                _c("td", [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm._f("price")(_vm.takeAwayTotal))
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm.$store.state.onlineServiceFee
                            ? _c("tr", [
                                _c("td", [
                                  _vm._v(" Gebühr bei Onlinezalung: "),
                                ]),
                                _c("td", [
                                  _c("span", { staticClass: "text-no-wrap" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("price")(
                                          _vm.$store.state.onlineServiceFee
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm.showCurrency
                        ? _c("div", [_vm._v("Alle Preisangaben inkl. MwSt.")])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm.$store.getters.enableStempel &&
                  !_vm.$store.getters.hasStempelInCart
                    ? _c(
                        "div",
                        {
                          staticClass: "hidden-sm-and-up mt-3 mb-4 text-center",
                        },
                        [_c("SmallStempelkarte")],
                        1
                      )
                    : _vm._e(),
                  _vm.$store.state.enableEnterCode
                    ? _c(
                        "div",
                        { staticClass: "hidden-sm-and-up mt-3 text-center" },
                        [_c("EnterCode")],
                        1
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm.showMinHint && _vm.$store.getters.payerSum < _vm.minOrderAmount
            ? _c("div", { staticClass: "indented myWarning" }, [
                _c("div", [
                  _vm._v("Es fehlen noch "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm._f("price")(
                          _vm.minOrderAmount - _vm.$store.getters.payerSum
                        )
                      )
                    ),
                  ]),
                  _vm._v(" für den"),
                  _c("br"),
                  _c("strong", [
                    _vm._v(
                      "Mindestbestellwert von " +
                        _vm._s(_vm._f("price")(_vm.minOrderAmount))
                    ),
                  ]),
                  _vm._v(" für " + _vm._s(_vm.describeUsecase) + " "),
                ]),
                _c("div"),
              ])
            : _vm._e(),
          _vm.$store.getters.orderingEnabled === false
            ? _c("div", { staticClass: "indented myWarning" }, [
                _c("h3", { staticClass: "text-center" }, [
                  _vm._v("Aktuell sind keine Online Bestellungen möglich!"),
                ]),
                _vm._v(" Versuche es in ein paar Minuten erneut. "),
              ])
            : _vm._e(),
        ],
        2
      ),
      !_vm.showButton
        ? _c(
            "v-container",
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn-mini",
                  on: {
                    click: function ($event) {
                      return _vm.$ebus.$emit("forceReload")
                    },
                  },
                },
                [_vm._v("Seite neu laden")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "spacer-40" }),
      _c("div", { staticClass: "spacer-25" }),
      _c("notes-dialog", {
        attrs: { dialog: _vm.notesDialog, item: _vm.selectedItem },
        on: {
          close: function ($event) {
            _vm.notesDialog = false
            _vm.rememberItems()
          },
        },
      }),
      _c("tischnummer-dialog", {
        attrs: { dialog: _vm.showTischnummer },
        on: {
          tnumberselected: _vm.tnumberselected,
          close: function ($event) {
            _vm.showTischnummer = false
          },
        },
      }),
      _vm.itemsCount > 0 &&
      _vm.showButton &&
      _vm.$store.state.cartId.length === 0
        ? _c("FixOrderNow", {
            on: {
              ordernow: _vm.doOrder,
              more: _vm.gotoSpeisen,
              next: _vm.clickGotoOrder,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }